/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EReviewStatus } from './EReviewStatus';
import {
    EReviewStatusFromJSON,
    EReviewStatusFromJSONTyped,
    EReviewStatusToJSON,
    EReviewStatusToJSONTyped,
} from './EReviewStatus';
import type { UploadedFileResponseDto } from './UploadedFileResponseDto';
import {
    UploadedFileResponseDtoFromJSON,
    UploadedFileResponseDtoFromJSONTyped,
    UploadedFileResponseDtoToJSON,
    UploadedFileResponseDtoToJSONTyped,
} from './UploadedFileResponseDto';

/**
 * 
 * @export
 * @interface ReviewNoteResponseDto
 */
export interface ReviewNoteResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof ReviewNoteResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReviewNoteResponseDto
     */
    updatedAt: Date;
    /**
     * ID of the submission this review note is associated with
     * @type {string}
     * @memberof ReviewNoteResponseDto
     */
    submissionId: string;
    /**
     * Free-text field for underwriting-related notes
     * @type {string}
     * @memberof ReviewNoteResponseDto
     */
    underwritingNotes?: string;
    /**
     * Selection of peer review status options
     * @type {EReviewStatus}
     * @memberof ReviewNoteResponseDto
     */
    reviewStatus?: EReviewStatus;
    /**
     * Free-text field for reviewer comments
     * @type {string}
     * @memberof ReviewNoteResponseDto
     */
    peerReviewNotes?: string;
    /**
     * Selectable date for review approval
     * @type {Date}
     * @memberof ReviewNoteResponseDto
     */
    approvedDate?: Date;
    /**
     * 
     * @type {Array<UploadedFileResponseDto>}
     * @memberof ReviewNoteResponseDto
     */
    files?: Array<UploadedFileResponseDto>;
}



/**
 * Check if a given object implements the ReviewNoteResponseDto interface.
 */
export function instanceOfReviewNoteResponseDto(value: object): value is ReviewNoteResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function ReviewNoteResponseDtoFromJSON(json: any): ReviewNoteResponseDto {
    return ReviewNoteResponseDtoFromJSONTyped(json, false);
}

export function ReviewNoteResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewNoteResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'submissionId': json['submissionId'],
        'underwritingNotes': json['underwritingNotes'] == null ? undefined : json['underwritingNotes'],
        'reviewStatus': json['reviewStatus'] == null ? undefined : EReviewStatusFromJSON(json['reviewStatus']),
        'peerReviewNotes': json['peerReviewNotes'] == null ? undefined : json['peerReviewNotes'],
        'approvedDate': json['approvedDate'] == null ? undefined : (new Date(json['approvedDate'])),
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(UploadedFileResponseDtoFromJSON)),
    };
}

export function ReviewNoteResponseDtoToJSON(json: any): ReviewNoteResponseDto {
    return ReviewNoteResponseDtoToJSONTyped(json, false);
}

export function ReviewNoteResponseDtoToJSONTyped(value?: ReviewNoteResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'submissionId': value['submissionId'],
        'underwritingNotes': value['underwritingNotes'],
        'reviewStatus': EReviewStatusToJSON(value['reviewStatus']),
        'peerReviewNotes': value['peerReviewNotes'],
        'approvedDate': value['approvedDate'] == null ? undefined : ((value['approvedDate']).toISOString()),
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(UploadedFileResponseDtoToJSON)),
    };
}

